import CASL from '@/utils/constants/casl'

export default {
  path: 'app-privacy-policy',
  children: [
    {
      path: '',
      name: 'app-privacy-policy.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.MOBILE_APP_SETUP
      },
      component: () => import('./list/AppPrivacyPolicyPage.vue')
    }
  ]
}
